<script>

import EventBus from "@/common/EventBus"
import Icon from "@/components/Icon/Icon.vue"
import AutoLogout from "@/components/connexion/AutoLogout.vue"
import FirstConnexion from "@/components/connexion/FirstConnexion.vue"
import MobilePage from "@/pages/MobilePage.vue"
import store from '@/store'
import router from '@/router'

export default {
  components: {
            Icon,
            AutoLogout,
            FirstConnexion,
            MobilePage,
        },
  computed: {
    currentUser() {
      return store.state.auth.user
    },
    currentAccountName() {
        return store.state.account?.name
    },
    currentAccountSid() {
        return store.state.account?.sid
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN')
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR')
      }

      return false
    }
  },
  methods: {
    logOut() {
      store.dispatch('auth/logout')

      if(localStorage.getItem('account_name'))
        router.push({name: 'login_account'})
      else
        router.push({name: 'login'})
    },
    beforeDestroy() {
      EventBus.remove('logout')
    }
  }
};
</script>

<template>

<div class="font-primary w-full mx-auto overflow-hidden">
  <div class="hidden sm:block">
    <AutoLogout></AutoLogout>
    <FirstConnexion></FirstConnexion>

    <nav class="bg-neutral-800 text-white sticky navbar navbar-expand navbar-dark bg-dark flex flex-column justify-between p-2">
      <div class="">Lune et Pistache</div>
      <!--z-[2000] top-0-->
      <div v-if="currentUser && currentAccountName" class="navbar-nav flex flex-column">
        <div>
          <router-link :to="{name: 'agenda', params: {account: currentAccountSid}}" class="nav-link">
            Agenda [{{ $store.state.account.name }}]
          </router-link>
        </div>
      </div>
      
      <div v-if="currentUser" class="navbar-nav flex gap-4">
        <div class="my-2 w-4">
          <router-link :to="{name: 'client'}" title="Clients">
            <icon name="persons" :size="30" color="white" />
          </router-link>
        </div>
        <div class="my-2 w-4">
          <router-link
            :to="{name: 'setting', params: {account: currentAccountSid}}"
            title="Configuration"
          >
            <icon name="setting" :size="30" color="white" />
          </router-link>
        </div>
        <div class="my-2 w-4">
          <router-link :to="{name: 'dashboard'}" title="Comptes">
            <icon name="dashboard" :size="30" color="white" />
          </router-link>
        </div>
        <div class="my-2 w-4">
          <a class="hover:cursor-pointer" @click.prevent="logOut" title="Se déconnecter">
            <icon name="exit" :size="30" color="white" />
          </a>
        </div>
      </div>
    </nav>

    <div>
      <router-view />
    </div>
  </div>
  <div class="block sm:hidden">
    <MobilePage />
  </div>
</div>

</template>
